export default "__VITE_PUBLIC_ASSET__85f002a5__"